import * as React from "react";
import { useState, useCallback } from "react";
import { Badge, GLCheckboxWithScope, Row, RowTitleButton } from "common/components";
import { DataTable, RiskScoreBadge } from "security-app/components/common";
import { useGetSecurityEvent } from "security-app/hooks/useSecurityEventsAPI";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import OwnerCell from "security-app/components/SecurityEvents/Alerts/OwnerCell";
import SecurityEventDetailsDrawer from "./SecurityEventDetailsDrawer";
function EventList({ securityEvents = [], onEventSelect = void 0 }) {
  const [currentEventId, setCurrentEventId] = useState();
  const selectedSecEvents = useSelectedRows();
  const selectedSecEventsDispatch = useSelectedRowsDispatch();
  const needsDrawer = !onEventSelect;
  const { securityEvent: selectedEvent, loadingSecurityEvents } = useGetSecurityEvent(needsDrawer ? currentEventId : void 0);
  const onRowTitleClick = (inSecurityEvent) => () => {
    if (onEventSelect) {
      onEventSelect(inSecurityEvent.event_id);
      return;
    }
    if (inSecurityEvent.id === currentEventId) setCurrentEventId(void 0);
    else setCurrentEventId(inSecurityEvent.id);
  };
  const isSelected = useCallback(
    (secEvent) => !!selectedSecEvents.find((sSecEvent) => secEvent.event_id === sSecEvent.event_id),
    [selectedSecEvents]
  );
  const onSelect = useCallback(
    (secEvent) => (e) => {
      if (e.target.checked) {
        selectedSecEventsDispatch({ type: "add", payload: [secEvent], key: "event_id" });
      } else {
        selectedSecEventsDispatch({ type: "remove", payload: [secEvent], key: "event_id" });
      }
    },
    [selectedSecEventsDispatch]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DataTable, { condensed: true, striped: true }, /* @__PURE__ */ React.createElement("tbody", null, securityEvents.map((securityEvent) => {
    var _a;
    return /* @__PURE__ */ React.createElement(DataTable.Row, { key: securityEvent.event_id }, /* @__PURE__ */ React.createElement(DataTable.Item, { $width: "34px" }, /* @__PURE__ */ React.createElement(GLCheckboxWithScope, { entity: securityEvent, isSelected, onSelect })), /* @__PURE__ */ React.createElement(DataTable.Item, { $width: "350px" }, /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: onRowTitleClick(securityEvent) }, securityEvent.message)), /* @__PURE__ */ React.createElement(DataTable.Item, null, /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "space-between" }, securityEvent.owner ? /* @__PURE__ */ React.createElement(OwnerCell, { owner: securityEvent.owner }) : /* @__PURE__ */ React.createElement("i", null, "No owner assigned"), /* @__PURE__ */ React.createElement(Badge, null, securityEvent.status), /* @__PURE__ */ React.createElement("div", { style: { width: 50, textAlign: "right" } }, /* @__PURE__ */ React.createElement(RiskScoreBadge, { riskScore: (_a = securityEvent.scores) == null ? void 0 : _a.normalized_risk })))));
  }))), !onEventSelect && !!currentEventId && !loadingSecurityEvents && selectedEvent && /* @__PURE__ */ React.createElement(SecurityEventDetailsDrawer, { secEvent: selectedEvent, onClose: () => setCurrentEventId(void 0) }));
}
export default EventList;
